import { render, staticRenderFns } from "./add-to-cart.vue?vue&type=template&id=1d520d9f"
import script from "./add-to-cart.vue?vue&type=script&lang=js"
export * from "./add-to-cart.vue?vue&type=script&lang=js"
import style0 from "./add-to-cart.vue?vue&type=style&index=0&id=1d520d9f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports